import {
  Component,
  OnInit,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DvButtonComponent } from '@devinco/ui/dds';
import {
  DvDateTimePickerElement,
  DvDynamicFormElement,
  DvDynamicFormModule,
  DvFormUtils,
  FormOf,
} from '@devinco/ui/legacy';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '@shared/pipes/pipes.module';

@Component({
  selector: 'app-historical-position-dialog',
  imports: [
    DvButtonComponent,
    TranslateModule,
    DvDynamicFormModule,
    PipesModule,
  ],
  templateUrl: './historical-position-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './historical-position-dialog.component.scss',
})
export class HistoricalPositionDialogComponent implements OnInit {
  formGroup: FormGroup<FormOf<{ dateAndTime: string }>>;
  elements: DvDynamicFormElement[];

  cancelClicked = output<void>();
  confirmClicked = output<string | undefined>();

  ngOnInit(): void {
    this.elements = this.getElements();
    this.formGroup = DvFormUtils.createFormGroup(this.elements);
  }

  onConfirmClick(): void {
    this.confirmClicked.emit(this.formGroup.value.dateAndTime);
  }

  onCancel(): void {
    this.cancelClicked.emit();
  }

  private getElements(): DvDynamicFormElement[] {
    return [
      new DvDateTimePickerElement({
        key: 'dateAndTime',
        label: 'HistoricPosition.DateAndTime',
        colspan: 7,
        clearable: false,
        maxDate: new Date(),
      }),
    ];
  }
}
